import { useAuth0 } from '@auth0/auth0-react'
import { useMutation } from '@tanstack/react-query'

import { SupportedLanguage } from '@estercare/ester-shared'
import { postEmailTestTemplate } from './test'

export const useTesttMutation = () => {
  const { getAccessTokenSilently } = useAuth0()

  return useMutation({
    mutationFn: async ({ templateName, language }: { templateName: string; language: SupportedLanguage }) => {
      const accessToken = await getAccessTokenSilently()
      if (!accessToken) {
        throw new Error('Access token is required to send email')
      }
      return await postEmailTestTemplate({ accessToken, templateName, language })
    },
    onError: (error) => {
      if (error.message) throw new Error(`Failed to send email ${error}`)
    },
  })
}
